import React from 'react';
import { Tooltip as KendoTooltip, TooltipProps as KendoTooltipProps } from '@progress/kendo-react-tooltip';
import cn from 'clsx';

import styles from './styles.module.scss';

interface TooltipProps extends KendoTooltipProps {
    isError?: boolean;
    isInactive?: boolean;
}

const Tooltip = ({ children, isError, isInactive, tooltipClassName, ...rest }: TooltipProps) => {
    const classes = cn(tooltipClassName, styles.tooltipScroll, {
        'validation-error': isError,
        'inactive-state': isInactive,
    });

    return (
        <KendoTooltip anchorElement="target" tooltipClassName={classes} {...rest}>
            {children}
        </KendoTooltip>
    );
};

export default Tooltip;
